<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other 401(k) plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_401k_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_401k_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other Profit Sharing plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_profit_sharing_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_profit_sharing_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other 401(k) Profit Sharing plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_401k_profit_sharing_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_401k_profit_sharing_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other ESOPs exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_esop_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_esop_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other KSOPs exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_ksop_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_ksop_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other 403(b) plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_403b_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_403b_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other 457 plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_457_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_457_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other frozen Defined Benefit plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="
                $v.formData.other_benefit_plans_defined_benefit_frozen_yesno
              "
            >
              <roe-radio-input
                v-model="
                  formData.other_benefit_plans_defined_benefit_frozen_yesno
                "
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other active Defined Benefit plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="
                $v.formData.other_benefit_plans_defined_benefit_active_yesno
              "
            >
              <roe-radio-input
                v-model="
                  formData.other_benefit_plans_defined_benefit_active_yesno
                "
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other Cash Balance plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_cash_balance_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_cash_balance_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other Non-Qualified plans exist for this Employer?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_non_qualified_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_non_qualified_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Do other Retiree Health plans exist for this Employee?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message
              :field="$v.formData.other_benefit_plans_retiree_health_yesno"
            >
              <roe-radio-input
                v-model="formData.other_benefit_plans_retiree_health_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { mapMutations } from "vuex";
import { SET_INVALID_FORM_STATE } from "@/store/mutations.type";
import { required } from "vuelidate/lib/validators";

export default {
  name: "RoeOtherBenefitPlansForm",
  props: ["formData"],
  created() {
    this.setNextButtonState({ isInvalid: this.$v.$invalid });
  },
  watch: {
    "$v.$invalid": function(value) {
      this.setNextButtonState({ isInvalid: value });
    }
  },
  validations() {
    return {
      formData: {
        other_benefit_plans_401k_yesno: { required },
        other_benefit_plans_profit_sharing_yesno: { required },
        other_benefit_plans_401k_profit_sharing_yesno: { required },
        other_benefit_plans_esop_yesno: { required },
        other_benefit_plans_ksop_yesno: { required },
        other_benefit_plans_403b_yesno: { required },
        other_benefit_plans_457_yesno: { required },
        other_benefit_plans_defined_benefit_frozen_yesno: { required },
        other_benefit_plans_defined_benefit_active_yesno: { required },
        other_benefit_plans_cash_balance_yesno: { required },
        other_benefit_plans_non_qualified_yesno: { required },
        other_benefit_plans_retiree_health_yesno: { required }
      }
    };
  },
  components: {
    RoeErrorMessage,
    RoeRadioInput
  },
  methods: {
    ...mapMutations({
      setNextButtonState: SET_INVALID_FORM_STATE
    })
  }
};
</script>
